import Hoowy from '../component/page/Hoowy';

const namedMap = {
    'hoowy': <Hoowy/>,
};

export default namedMap;
